module.exports = "<span defaultOverlayTarget></span>\r\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 1085
// module chunks = 0